<div class="d-flex flex-column h-100 srt_kiosk_page" id="srtKioskDashboard">
    <!-- SRT Kiosk Data heading and info -->
    <div class="srt_data_header" id="srtKioskDataHeader">
        <div class="srt_left_side_section" id="leftSrtSection">
            <div class="srt_results_info" id="srtResultInfo">
                <div class="srt_title" id="srtTitle"><strong><span
                            i18n="@@device-dashboard.results-label.list-of-devices">List of Devices</span></strong>
                </div>
                <div class="srt_results" id="srtResults">
                    <span i18n="@@device-dashboard.results-info.showing-from-to-devices">Showing <strong>{{ showFrom }}
                            - {{ showTo }} </strong> of <strong> {{ srtPaginationCount }} Devices</strong></span>
                </div>
            </div>
            <div class="row mx-2 flex-column" [ngClass]="blockServiceCall ? 'mt-4':''" id="searchSrtKioskOnEnter">
                <div class="input-group" id="searchSrtKioskTextBox">
                    <input type="search" #searchSrtValue [(ngModel)]="searchSrtData"
                        [ngClass]="blockServiceCall ? 'red-border':''"
                        (keyup.enter)="searchSrtDevicessonEnter(searchSrtData)" [placeholder]="searchSrtLabel"
                        (ngModelChange)="clearSrtSearch(searchSrtData)" class="form-control srt_kiosk_search_textbox"
                        placeholder="Search.." />
                    <div ngbDropdown class="btn-group">
                        <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                            id="srtsizeDropDown" aria-haspopup="true" aria-expanded="false">
                            {{valueForSearchInSrtDevice}}
                        </button>
                        <div id="srt_search_filter" ngbDropdownMenu aria-labelledby="sizeDropDown">
                            <a ngbDropdownItem selected="selected" *ngIf="valueForSearchInSrtDevice != deviceIdVal"
                                (click)="onSrtSelectChange('1')">
                                <span>{{deviceConst.SRT_DEVICE_ID_TEXT}}</span></a>
                            <a ngbDropdownItem *ngIf="valueForSearchInSrtDevice != srtDeviceNameVal"
                                (click)="onSrtSelectChange('2')">
                                <span i18n="@@device-dashboard.dropdown.device-name">Device Name</span></a>
                            <a ngbDropdownItem *ngIf="valueForSearchInSrtDevice != srtStoreNameVal"
                                (click)="onSrtSelectChange('3')">
                                <span i18n="@@device-dashboard.dropdown.store-name">Store Name</span></a>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-primary srt_search_btn" (click)="searchSrtDevice(searchSrtData)">
                <img class="srt-search-icon" alt="search">
            </button>
        </div>
        <div *ngIf="displaySrtDevices?.length > 0" class="srt_action_buttons" id="srtActionButtons">
            <button class="btn btn-outline-primary btn-lg srt_left_icon_btn"
                [ngClass]="isButtonsDisabled ? 'disable-buttons': ''" [disabled]="isButtonsDisabled" (click)="removeAllSelectedSrtDevice()">
                <img [ngClass]="isButtonsDisabled ? 'remove-selected-img-disabled' : 'remove-selected-img'"
                    alt="remove-selected">
                <span i18n="@@device-dashboard.action-button.remove-selected">Remove Selected</span>
            </button>
            <button class="btn btn-primary btn-lg left_icon_btn" (click)="updateMultiSrtDevices(updateSrtModal)"
                [ngClass]="isButtonsDisabled ? 'disable-buttons': ''" [disabled]="isButtonsDisabled">
                <img [ngClass]="isButtonsDisabled ? 'update-selected-img-disabled' : 'update-selected-img'"
                    alt="update-selected">
                <span i18n="@@device-dashboard.action-button.update-selected">Update selected</span>
            </button>
        </div>
    </div>

    <!-- SRt Kiosk Filter options -->
    <div class="srt_filter_options" id="srtFilterOptions" *ngIf="displaySrtDevices?.length > 0 || closeSrtFilter">
        <form class="form-inline srt-filter-option-width">
            <strong><span i18n="@@device-dashboard.filter-option.filters">Filters</span></strong>
            <select *ngIf="!srtConnectivityStatusDropdownsrtSelectedValue" #drop1
                (change)="onSrtFilter(srtConnectivityStatusFilterName, drop1.value)"
                class="srt-btn-greyscale btn-sm dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                <option selected default hidden><span
                        i18n="@@device-dashboard.table-headings.connectivity-status">Connectivity Status</span></option>
                <option class="dropdown-item" *ngFor="let srtConnectedStatus of allSrtConnectivityStatus"
                    [value]="srtConnectedStatus">
                    {{srtSpell(srtConnectedStatus)}}
                </option>
            </select>
            <div class="srt-dropdown-selected" id="srtdropdownSelected"
                *ngIf="srtConnectivityStatusDropdownsrtSelectedValue">{{srtConnectivityStatusDropdownsrtSelectedValue}}
                <img src="assets/images/close.svg" class="srt-dropdown-selected-img"
                    (click)="clearSrtFilter(srtConnectivityStatusFilterName)" alt="close filter" />
            </div>
            <select *ngIf="!srtStoreNameDropdownSelectedValue" #drop2
                (change)="onSrtFilter(srtStoreNameFilterName, drop2.value)"
                class="srt-btn-greyscale btn-sm dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                <option selected default hidden><span>Store Name</span></option>
                <option class="dropdown-item" *ngFor="let storeName of allStoreNameData" [value]="storeName">
                    {{storeName}}
                </option>
            </select>
            <div class="srt-dropdown-selected" *ngIf="srtStoreNameDropdownSelectedValue">
                {{srtStoreNameDropdownSelectedValue}}
                <img src="assets/images/close.svg" class="srt-dropdown-selected-img"
                    (click)="clearSrtFilter(srtStoreNameFilterName)" alt="close" />
            </div>
            <div id="srtKioskMoreFilters" *ngIf="showHideMoreFilters">
                <button type="button" class="btn btn-link btn-sm srt_right_icon_btn"
                    (click)="showHideMoreFiltersClick()">
                    <span i18n="@@device-dashboard.filter-option.more-filters">More Filters</span>
                    <span class="srt-more-filters-icon"></span>
                </button>
            </div>
            <ng-container *ngIf="!showHideMoreFilters">
                <select *ngIf="!srtVersionDropdownSelectedValue" #drop3
                    (change)="onSrtFilter(srtVersionFilterName, drop3.value)"
                    class="srt-btn-greyscale btn-sm dropdown-toggle" aria-haspopup="true" aria-expanded="false">
                    <option selected default hidden><span>{{deviceConst.SRT_VERSION_TEXT}}</span></option>
                    <option class="dropdown-item" *ngFor="let version of allSrtVersionData" [value]="version">
                        {{version}}
                    </option>
                </select>
                <div class="srt-dropdown-selected" *ngIf="srtVersionDropdownSelectedValue" id="brandDropDownVal">
                    {{srtVersionDropdownSelectedValue}}
                    <img src="assets/images/close.svg" class="srt-dropdown-selected-img"
                        (click)="clearSrtFilter(srtVersionFilterName)" alt="close" />
                </div>
                <div id="srthideFilterBtn">
                    <button type="button" class="btn btn-link btn-sm right_icon_btn"
                        (click)="showHideMoreFiltersClick()">
                        <span class="srt-hide-filters-icon"></span>
                        {{deviceConst.HIDE_FILTERS}}
                    </button>
                </div>
            </ng-container>
        </form>
        <div class="btn btn-link srt_left_icon_btn" (click)="clearSrtFilter()" *ngIf="closeSrtFilter"
            id="clearLeftFilters">
            <span class="clear-srt-filters-icon"></span>
            <span i18n="@@device-dashboard.filter-option.clear-filters">Clear Filters</span>
        </div>
    </div>
    <hr />

    <!-- SRT Kiosk Table data -->
    <div id="srtKioskTableData">
        <div class="table-responsive" id="srtKioskTblResponsive">
            <table id="srtKioskDevicesTable" class="table table-borderless" aria-describedby="devicesTable">
                <thead>
                    <tr *ngIf="displaySrtDevices?.length">
                        <th scope="col">
                            <span class="srt_table_headings">
                                <input type="checkbox" [checked]='isMasterSel'
                                    (change)="checkAndUncheckSrt($event.target.checked)" name="srt_list_name"
                                    value="" />
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings">
                                <span>PC Finder Device ID</span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings srt_device_name" (click)="sortSrtValues(srtDeviceName)">
                                <span i18n="@@device-dashboard.dropdown.device-name">Device Name</span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings" (click)="sortSrtValues(srtConnectivityStatus)">
                                <span i18n="@@device-dashboard.table-headings.connectivity-status">Connectivity
                                    Status</span>
                                <span class="info_icon" [ngbPopover]="srtConnectivityStatusHoverText"
                                    triggers="mouseenter:mouseleave">
                                    <div class="srt-round-info-icon"></div>
                                </span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings" (click)="sortSrtValues(srtStoreName)">
                                <span>Store Name</span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings" (click)="sortSrtValues(srtStoreNumber)">
                                <span i18n="@@device-dashboard.dropdown.store-number">Store Number</span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings" (click)="sortSrtValues(srtVersion)">
                                <span>{{deviceConst.SRT_VERSION_TEXT}}</span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings" (click)="sortSrtValues(srtLastUpdate)">
                                <span i18n="@@device-dashboard.table-headings.last-update">Last Update</span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings" (click)="sortSrtValues(srtSyncStatus)">
                                <span>Sync Status</span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="srt_table_headings" (click)="sortSrtValues(srtLastConnectedTime)">
                                <span>Last Connected</span>
                                <span class="srt_chevron_expand"></span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of displaySrtDevices">
                        <tr>
                            <td class="text-center">
                                <input type="checkbox" [checked]='isAllItemsSelectedData.has(item?.deviceID)'
                                    (change)="isAllSrtSelected(item)" name="list_single_srt_name" id="srt_single" />
                            </td>
                            <td>{{item?.deviceID}}</td>
                            <td>{{item?.deviceName}}</td>
                            <td class="srt_connected_status">
                                <em *ngIf="item.connectivityStatus == deviceConst.INACTIVE || item.connectivityStatus == deviceConst.TWO_WEEKS"
                                    class="srt_dev_inactive_icon"></em>
                                <em *ngIf="item.connectivityStatus == deviceConst.RECENTLY_CONNECTED || item.connectivityStatus == deviceConst.CONNECTED"
                                    class="srt_dev_connected_icon"></em>
                                <em *ngIf="item.connectivityStatus == deviceConst.DISCONNECTED"
                                    class="srt_dev_disconnected_icon"></em>
                                <div id="srt_connectivityStatus">{{srtSpell(item.connectivityStatus)}}
                                    <div *ngIf="item.connectivityStatus == 'Inactive'" class="srt-status-text"
                                        id="srt_inactiveStatus">{{item?.connectivityStatusText}}</div>
                                </div>
                            </td>
                            <td>{{item?.storeName}}</td>
                            <td>{{item?.storeNumber}}</td>
                            <td>{{item.srtVersion}}</td>
                            <td>{{item.deviceUpdatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                            <td>{{item.syncStatus}}</td>
                            <td>{{item.lastConnectedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                            <td class="srt_action_cell" *ngIf="isButtonsDisabled">
                                <span class="srt_edit_record" (click)="updateSrtDevice(updateSrtModal,item)">
                                    <div [ngbTooltip]="srtUpdateHoverText" placement="top" container='body'
                                        class="srt-edit-icon"></div>
                                </span>
                                <span class="srt_delete_record" (click)="removeSrtItem(item)">
                                    <div [ngbTooltip]="srtRemoveIconText" placement="top" container='body'
                                        class="srt-delete-icon"></div>
                                </span>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <hr *ngIf="displaySrtDevices?.length > 0" />
        </div>
        <div *ngIf="!displaySrtDevices?.length" id="displaySrtDevices">
            <p class="center-records-text" *ngIf='isSrtDataEmpty else loading'>{{globalConst.NO_RECORDS_FOUND}}</p>
            <ng-template #loading>
                <p class="text-center">{{globalConst.LOADING}}</p>
            </ng-template>
        </div>
    </div>
    <!-- SRT Kiosk Pagination -->
    <div class="srt_kiosk_data_footer position-relative" *ngIf="displaySrtDevices?.length > 0"
        id="srtKioskFooterPagination">
        <div class="d-flex flex-column align-items-center" id="srtPaginationAlignItems">
            <nav aria-label="srt dashboard pagination">
                <ngb-pagination [collectionSize]="srtPaginationCount" [(page)]="pageVal" [pageSize]="srtTableSize"
                    [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
                    (pageChange)="onSrtTableDataChange($event)">
                </ngb-pagination>
            </nav>
            <div class="srt_results mt-2" id="srtresultsDiv">
                <span i18n="@@device-dashboard.results-info.showing-from-to-devices">Showing <strong>{{ showFrom }} - {{
                        showTo }} </strong> of <strong> {{ srtPaginationCount }} Devices</strong></span>
            </div>
        </div>
    </div>
    <div class="srt_file_buttons d-flex mt-3" id="SrtKioskFileButtons" *ngIf="displaySrtDevices?.length > 0">
        <button type="button" (click)="downloadSrtDevices()" class="btn btn-outline-primary mr-4 btn-link">
            <img class="download-csv-btn" alt="download-csv-btn" />
            <span i18n="@@device-dashboard.footer-button.download-csv">Download CSV</span>
        </button>
    </div>
</div>
<!--For Profile List Popup-->
<ng-template #updateSrtModal>
    <div class="card deletePopup" dir={{direction}} id="updateProfilePopup">
        <div class="close" (click)="dismissUpdate()" id="closeUpdateIcon">
            <img class="modal-close-icon" alt="close icon" />
        </div>
        <div class="modal-body" id="updateSrtModalBody">
            <div class="header" id="updateSrtHeader">
                <ng-template #bulkUpdatePopupHeader>{{selectedSrtDevicesList?.length}} {{srtDevicesText}}
                </ng-template>
                <div class="heading" *ngIf="selectedSrtDevicesList.length <= 1" id="updateSrtDeviceName">
                    {{updateSrtDeviceInfo?.deviceName}}</div>
                <div class="heading" *ngIf="selectedSrtDevicesList.length > 1" id="devicesSrtText">
                    {{selectedSrtDevicesList?.length}}
                    {{srtDevicesText}}&nbsp;
                    <span [ngbPopover]="selectedSrtDevicesNameList" selector="true" placement="right"
                        triggers="mouseenter" [autoClose]="true" [popoverTitle]="bulkUpdatePopupHeader">
                        <span class="srt-round-info-icon"></span>
                    </span>
                </div>
                <div class="srt-device_identity" *ngIf="selectedSrtDevicesList.length <= 1" id="deviceSrtIdentity">
                    <strong><span [innerHTML]='updateStoreID'></span></strong> {{updateSrtDeviceInfo?.storeID}} |
                    <strong><span [innerHTML]='updateDeviceID'></span></strong>
                    {{updateSrtDeviceInfo?.deviceID}}
                </div>
                <div class="device-name-wrap" *ngIf="selectedSrtDevicesList.length > 1" id="deviceSrtNameWrap">
                    {{selectedSrtDevicesNameList}}</div>
            </div>
            <div class="srt_data_header" id="profileDataHeader">
                <div class="srt_left_side_section" id="profile name">
                    <div class="srt_title" id="profileTitle"><strong><span>Profiles</span></strong>
                    </div>
                </div>
                <div *ngIf="displayDownloadedProfileData?.length > 0" class="srt_results" id="profileResults">
                    <span i18n="@@device-dashboard.results-info.showing-from-to-devices">Showing <strong>{{ showFrom }}
                            - {{ showTo }} </strong> of <strong> {{ displayDownloadedProfileData?.length }}
                            Profiles</strong></span>
                </div>
            </div>
            <hr>
            <div id="profileUpdateData">
                <div class="table-responsive" id="profileUpdateTblResponsive">
                    <table id="srtKioskDevicesTable" class="table table-borderless" aria-describedby="ProfileTable">
                        <thead>
                            <tr *ngIf="displayDownloadedProfileData?.length > 0">
                                <th scope="col">
                                </th>
                                <th scope="col" [iposcenSort]="displayDownloadedProfileData" data-order="desc" data-name="profileName">
                                    <span i18n="@@profile.table.profile">Profile</span> &nbsp; <em class="srt_chevron_expand"></em>
                                </th>
                                <th scope="col" [iposcenSort]="displayDownloadedProfileData" data-order="desc" data-name="updatedDate">
                                    <span>Last Update</span> &nbsp; <em class="srt_chevron_expand"></em>
                                </th>
                                <th scope="col" [iposcenSort]="displayDownloadedProfileData" data-order="desc" data-name="languages">
                                    <span i18n="@@profile.table.languages">Languages</span> &nbsp; <em class="srt_chevron_expand"></em>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let item of displayDownloadedProfileData | slice: (pageVal-1) * srtTableSize : pageVal * srtTableSize">
                                <tr>
                                    <td class="text-center">
                                        <input type="radio" [(ngModel)]="selectedProfileId"
                                            (change)="selectProfileId(item, $event)" [value]="item.profileId"
                                            [checked]="selectedProfileId === item.profileId" name="profiles_selection"
                                            id="profile_radio_btn" />
                                    </td>
                                    <td>{{item?.profileName}}</td>
                                    <td>{{item.updatedDate | dateFormat:'changeToLocalTimeZone'}}</td>
                                    <td>{{getLanguageNames(item?.languages)}}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                    <hr *ngIf="displayDownloadedProfileData?.length > 0" />
                </div>
                <div *ngIf="!displayDownloadedProfileData?.length" id="displayProfileData">
                    <p class="center-records-text" *ngIf='isDownloadedProfileEmpty else loading'>
                        {{globalConst.NO_RECORDS_FOUND}}</p>
                    <ng-template #loading>
                        <p class="text-center">{{globalConst.LOADING}}</p>
                    </ng-template>
                </div>
            </div>
            <!-- Profile data Pagination -->
            <div class="srt_kiosk_data_footer position-relative" *ngIf="displayDownloadedProfileData?.length > 0"
                id="profileDataPagination">
                <div class="d-flex flex-column align-items-center" id="profileAlignItems">
                    <nav aria-label="srt dashboard pagination">
                        <ngb-pagination [collectionSize]="displayDownloadedProfileData?.length" [(page)]="pageVal"
                            [pageSize]="srtTableSize" [rotate]="false" [maxSize]="maxSize" [ellipses]="true"
                            [boundaryLinks]="false" (pageChange)="onProfilePaginationClick($event)">
                        </ngb-pagination>
                    </nav>
                    <div class="srt_results mt-2" id="profileResults">
                        <span i18n="@@device-dashboard.results-info.showing-from-to-devices">Showing <strong>{{ showFrom
                                }} - {{
                                showTo }} </strong> of <strong> {{ displayDownloadedProfileData?.length }}
                                Devices</strong></span>
                    </div>
                </div>
            </div>
            <div *ngIf="displayDownloadedProfileData?.length > 0" class="button_wrapper justify-content-end" id="cancelProfilePush">
                <button type="button" (click)="dismissUpdate()" [disabled]="!isProfileIdSelected"
                    class="btn btn-outline-primary btn-lg" data-dismiss="modal">
                    <span>Cancel</span>
                </button>
                <button type="button" id="pushProfileUpdate" [disabled]="isProfileIdSelected ? '': 'disable-buttons'"
                    class="btn btn-primary btn-lg" (click)="pushSrtUpdates()">
                    <div [ngClass]="isProfileIdSelected ? 'push-update-btn' : 'push-update-btn-disabled'"></div>
                    <span>Push Updates</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>
<!-- For Push Profile Success Popup-->
<iposcen-push-update [deviceInfo]='updateSrtDeviceInfo' [deviceList]= 'selectedSrtDevicesList' (pushDone) = 'pushSrtStatus($event)' (pushClosed)="getSrtClosedStatus($event)" #pushUpdateModal></iposcen-push-update>
<!--IGC-6 Delete Individual/Multiple SRT Devices-->
<div class="container" id="openDeletedSrtModalContainer">
    <div class="modal-dialog-centered" *ngIf="openDeleteSrtModalPopup" id="openDeletedSrtModal">
        <div class="modal-backdrop show" id="openDeletedSrtModalBackDrop"></div>
        <div class="modal" id="mySrtModal">
            <div class="modal-dialog remove-modal-dialog" id="mySrtModalDialog">
                <div class="modal-content remove-content" *ngIf="isSrtDeviceRemoved" id="mySrtModalContainer">
                    <div class="close" (click)="cancelSrtPopupButton()" id="mySrtModalCloseIcons">
                        <img class="modal-close-icon" alt="close success icon" />
                    </div>
                    <div class="modal-body remove-body" id="mySrtModalBody">
                        <div class="heading remove-Heading" id="mySrtModalRemoveHeading">
                            <span  *ngIf="isSingleSrtDeviceSelected">Are you sure you want to remove {{deviceName}}?</span>
                            <span  *ngIf="!isSingleSrtDeviceSelected">Are you sure you want to remove these devices?</span>
                        </div>
                            <ng-container *ngIf="isSingleSrtDeviceSelected">
                                <span>You will no longer be able to remotely manage {{deviceName}}.</span>
                            </ng-container>
                            <ng-container *ngIf="!isSingleSrtDeviceSelected">
                                <span>This will remove {{selectedSrtDevicesList.length}} devices from IPOS Central.</span>
                            </ng-container>
                    </div>
                    <div class="modal-footer remove-footer" id="mySrtModalFooter">
                        <button type="button" class="btn btn-outline-primary btn-lg remove-btn" data-dismiss="modal"
                            (click)="cancelSrtPopupButton()">{{cancelSrtButton}}</button>
                        <button type="button" class="btn btn-primary btn-lg"
                            (click)="removeSrtDeviceList()">{{removeSrtDeviceMessage}}</button>
                    </div>
                </div>

                <div class="modal-content" *ngIf="!isSrtDeviceRemoved" id="mySrtModalContent">
                    <div class="card removePopup" id="mySrtModalRemovePopup">
                        <div class="modal-header" id="mySrtModalHeader">
                                <div class="close srt-device-removed" (click)="closeRemoveSrtDeviceModal()" id="mySrtModalRemoveSuccess">
                                    <img class="modal-close-icon" alt="close remove success icon" />
                                </div>
                        </div>
                        <div class="modal-body" id="mySrtModalBodyChild">
                            <div class="removesuccess_img_div text-center" id="removeSrtSuccessImg">
                                <span class="removesuccess_img"></span>
                            </div>
                            <ng-container *ngIf="isSingleSrtDeviceSelected">
                                <div class="removesuccess-title text-center" id="removeSrtSuccessTitle">
                                    <span>Device Removed</span>
                                </div>
                                <div class="removesuccess-content text-center" id="removeSrtSuccessContent">
                                    <span>{{deviceName}} has been removed.</span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isSingleSrtDeviceSelected">
                                <div class="removesuccess-title text-center" id="removeSrtSuccesseDiv">
                                    <span>Devices Removed</span>
                                </div>
                                <div class="removesuccess-content text-center" id="removeSrtSuccessContentDiv">
                                    <span>{{selectedSrtDevicesList.length}} devices has been removed.</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true"></iposcen-spinner-overlay>
<iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false"></iposcen-spinner-overlay>